var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-lg"},[_vm._v(_vm._s(_vm.field.displayLabel)+": "+_vm._s(_vm.field.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }